
function SdErrorPanelCtrl(TranslationService) {
    var ctrl = this;

    
}

SdErrorPanelCtrl.$inject = ['TranslationService'];

seedWebApp.component('sdErrorPanel', {
    controller: SdErrorPanelCtrl,
    bindings: {
        title: '<',
        error: '<',
    },
    templateUrl: '/SPA/Components/sd-error-panel.html'
});